import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { IDeps, TLabel } from './models';
import { Label as ComponentLabel } from './label';
import styles from './styles.css';

export const Label = createWidget<IDeps, TLabel>({
    styles,
})(ComponentLabel);
